<div class="container">
  <div class="content">
    <h2>{{ 'imprint.title' | translate }}</h2>
    <hr class="title-divider" />
    <h3>{{ 'imprint.responsibleForContent' | translate }}</h3>
    <span>{{ 'imprint.companyName' | translate }}</span>
    <span>{{ 'imprint.street' | translate }}</span>
    <span>{{ 'imprint.city' | translate }}</span>

    <div class="space"></div>

    <span>{{ 'imprint.phone' | translate }}: +49 89 96101-0</span>
    <span>{{ 'imprint.fax' | translate }}: +49 89 96101-1113</span>

    <div class="space"></div>

    <span>{{ 'imprint.email' | translate }}: <a href="mailto:info@msg.group">info@msg.group</a></span>

    <div class="space"></div>

    <span>{{ 'imprint.executiveBoard' | translate }}</span>
    <span>{{ 'imprint.executiveBoardMembers' | translate }}</span>
    <span>{{ 'imprint.executiveBoardMembers2' | translate }}</span>

    <div class="space"></div>

    <span>{{ 'imprint.chairman' | translate }}</span>

    <div class="space"></div>

    <span>{{ 'imprint.commercialRegister' | translate }}</span>
    <span>{{ 'imprint.court' | translate }}</span>
    <span>{{ 'imprint.registerNumber' | translate }}</span>

    <div class="space"></div>

    <span>{{ 'imprint.vatNumber' | translate }}</span>

    <div class="space"></div>

    <span class="date">{{ 'imprint.date' | translate }}</span>
  </div>
</div>
